<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="业主名称"
              hasFeedback
            >
              <a-input
                placeholder="请输入业主名称"
                id="name"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入业主名称！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="统一社会信用代码"
              hasFeedback
            >
              <a-input
                placeholder="请输入统一社会信用代码"
                id="number"
                :disabled="!isEdit"
                autocomplete="off"
                v-decorator="['number', { rules: [{ required: true, message: '请输入统一社会信用代码！' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item
              :labelCol="labelCol2"
              :wrapperCol="wrapperCol2"
              label="备注"
              hasFeedback
            >
              <a-textarea
                placeholder="请输入备注"
                id="remark"
                :disabled="!isEdit"
                v-decorator="['remark']"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <add-contacts ref="addContacts" v-if="visible" :proprietorId="proprietorId" ></add-contacts>
          </a-col>
          <a-col :span="24">
            <div style="text-align:right">
              <a-button type="primary" html-type="submit" style="margin-right:10px;" v-if="this.type !== this.$sysInfo.MODAL_VIEW">
                提交
              </a-button>
              <!--              <a-button style="margin-right:10px;" @click="cancel">-->
              <!--                取消-->
              <!--              </a-button>-->
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import addContacts from '@/views/contacts/addContacts.vue'
import { getProprietorsInfo, insertProprietors, updateProprietors } from '@/api/proprietors'
import { getContactsById } from '@/api/contacts.js'
export default {
  name: 'EditProprietors',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal,
    addContacts
  },
  data () {
    return {
      proprietorId: null,
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      }

    }
  },
  methods: {
    // 设置类型insta
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.$nextTick(() => {
        this.model = Object.assign({}, model)
        this.form.setFieldsValue({
          id: this.model.id,
          name: this.model.name,
          number: this.model.number,
          remark: this.model.remark,
          status: this.model.status
        })
      })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      // 修改或者查看的话，调用接口获取联系人列表
      let data = []
      this.$nextTick(function () {
        if (flag) {
          // 打开
          if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
            if (this.type === this.$sysInfo.MODAL_MODIFY) {
              this.$refs.addContacts.setMode('modify')
            } else {
              this.$refs.addContacts.setMode('view')
            }
            // 远程获取联系人资料
            getContactsById(this.model.id).then(res => {
              if (res.status === 0) {
                data = res.data
                this.$refs.addContacts.setDataList(data)
              }
              console.log('res', res)
            }).catch(err => {
              this.$message.warning('获取联系人失败！')
            })
          } else {
            this.$refs.addContacts.setMode('add')
            this.$refs.addContacts.setDataList(data)
          }
        } else {
          this.model.id = null
          // 关闭
          // this.$refs.addContacts.setDataList(data)
        }
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      let validate = false
      let contacts = []
      if (this.$refs.addContacts.validate()) {
        contacts = this.$refs.addContacts.getDataList()
        validate = true
      } else {
        this.$message.warning('请完善联系人姓名后再提交！')
      }
      if (validate) {
        this.form.validateFieldsAndScroll((err, value) => {
          if (!err) {
            const params = { ...this.model, ...value }
            params.contacts = contacts
            if (this.type === this.$sysInfo.MODAL_ADD) {
              if (params.id) delete params.id
              insertProprietors(params).then(res => {
                if (res.status === 0) {
                  this.$message.success(res.info.message)
                  this.$emit('refreshTable')
                  this.open(false)
                } else {
                  this.$message.error(res.info.message)
                }
              })
            } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
              updateProprietors(params).then(res => {
                if (res.status === 0) {
                  this.$message.success(res.info.message)
                  this.$emit('refreshTable')
                  this.open(false)
                } else {
                  this.$message.error(res.info.message)
                }
              })
            }
          }
        })
      }
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      getProprietorsInfo().then(res => {
        if (res.status === 0) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              id: this.model.id,
              name: this.model.name,
              number: this.model.number,
              remark: this.model.remark,
              status: this.model.status
            })
          })
          this.infoLoading = false
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    handleChange () {

    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({ id: '', name: '', number: '', remark: '', status: '' })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped>

</style>
